import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_MEMBERSHIP_PRODUCT = gql`
  query MembershipProduct(
    $membershipProductRequest: GetMembershipProductRequest
  ) {
    membershipProduct(membershipProductRequest: $membershipProductRequest) {
      offerAdded {
        type
      }
    }
  }
`;
